<template>
  <div>
    <custom-animation :data="animationData"></custom-animation>
  </div>
</template>

<script>
import CustomAnimation from '../CustomAnimationWithLottieWithModal';
import saving from './saving.json';

export default {
  components: {
    CustomAnimation
  },
  data() {
    return {
      animationData: saving
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
